var React = require('react');

function InfoIVideo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.61435 8.479V3.227H2.39335C1.70435 3.669 1.09335 3.968 0.521352 4.124V4.722C1.15835 4.787 1.40535 5.047 1.40535 5.736V8.466C1.40535 9.064 1.13235 9.376 0.495352 9.402V10H3.53735V9.402C2.90035 9.376 2.61435 9.064 2.61435 8.479ZM1.08035 1.069C1.08035 1.589 1.48335 2.005 2.02935 2.005C2.54935 2.005 2.95235 1.589 2.95235 1.069C2.95235 0.523 2.54935 0.132999 2.02935 0.132999C1.48335 0.132999 1.08035 0.523 1.08035 1.069Z","fill":"white"}));
}

InfoIVideo.defaultProps = {"width":"4","height":"10","viewBox":"0 0 4 10","fill":"none"};

module.exports = InfoIVideo;

InfoIVideo.default = InfoIVideo;
